/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid } from '@mui/material';
import { DialogDefaultV2, TrueFalseSelectV2 } from '../../../components/v2';

const ValidarDialog = ({ open, onClose, onConfirm, showDespesaFatura }) => {
  const [despesaFatura, setDespesaFatura] = useState('');
  const [foraEstado, setForaEstado] = useState('');
  const [possuiImpostoEmpresa, setPossuiImpostoEmpresa] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setDespesaFatura('');
      setForaEstado('');
      setPossuiImpostoEmpresa('');
      setErrors({});
    }
  }, [open]);

  const handleConfirm = () => {
    const nextErrors = {};
    if (!foraEstado) nextErrors.foraEstado = true;
    if (!possuiImpostoEmpresa) nextErrors.possuiImpostoEmpresa = true;
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) return;

    onConfirm({
      foraEstado,
      possuiImpostoEmpresa,
      despesaFatura: showDespesaFatura ? despesaFatura : undefined,
    });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={handleConfirm}
      title="Validar nota"
      confirmMessage="Validar"
      cancelMessage="Cancelar"
      maxWidth="sm"
      fullWidth
      useFullScreen={false}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Confirme a validação e classifique a nota para a contabilidade.
        {showDespesaFatura && ' Informe também se a despesa consta na fatura do cartão corporativo.'}
      </Typography>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>
          <TrueFalseSelectV2
            error={!!errors.foraEstado}
            isRequired
            label="Fora do estado (MG)"
            name="foraEstado"
            onChange={(event) => setForaEstado(event.target.value)}
            value={foraEstado}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <TrueFalseSelectV2
            error={!!errors.possuiImpostoEmpresa}
            isRequired
            label="Imposto a pagar (empresa)"
            name="possuiImpostoEmpresa"
            onChange={(event) => setPossuiImpostoEmpresa(event.target.value)}
            value={possuiImpostoEmpresa}
          />
        </Grid>
        {showDespesaFatura && (
          <Grid size={{ xs: 12 }}>
            <TrueFalseSelectV2
              label="Despesa na Fatura"
              name="despesaFatura"
              onChange={(event) => setDespesaFatura(event.target.value)}
              value={despesaFatura}
            />
          </Grid>
        )}
      </Grid>
    </DialogDefaultV2>
  );
};

ValidarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  showDespesaFatura: PropTypes.bool,
};

ValidarDialog.defaultProps = {
  showDespesaFatura: false,
};

export default ValidarDialog;
